<template>
  <transition name="appear">
    <div class="free-orders" v-if="open">
      <div class="free-orders__header">
        <h3 class="title">Ordens não sequenciadas</h3>
      </div>
      <OrderFilters :open="formOpen" :handleExpansion="handleExpansion" />
      <div class="free-orders__content">
        <Order
          v-for="(order, index) in $store.state.orders.free"
          :key="index"
          :orderName="order.codigo || order.label"
        ></Order>
      </div>
    </div>
  </transition>
</template>

<script>
import OrderFilters from "./OrdersFilters";
import Order from "./Order";

export default {
  name: "FreeOrders",
  components: { OrderFilters, Order },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    formOpen: true
  }),
  methods: {
    handleExpansion() {
      this.formOpen = !this.formOpen;
    }
  }
};
</script>

<style scoped>
.free-orders {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  background: var(--color-white);
  border-bottom: 1px solid var(--color-grey);
}

.free-orders__header {
  height: 2rem;
  display: flex;
}

.title {
  display: flex;
  align-items: center;
  margin-left: 1rem;
}

.free-orders__content {
  overflow-y: auto;
  padding: 1.5rem 1rem;
}
.material-icons-outlined.header__icon {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 2em;
  transition: background-color 0.3s;
}
.material-icons-outlined.header__icon:hover {
  background: #e2e8f0;
}
</style>
